import React, { useContext } from "react";
import { EditableCheckbox } from "../../Atoms/inputs/EditableCheckbox";
import { EditableFormAttributeValueProperty } from "../../Atoms/EditableProperties/EditableFormAttributeValueProperty";
import { WindowContext } from "../../Service/Context/WindowContext";
import { DocumentService } from "../../Service/DocumentService";
import { FormatS } from "../../Service/FormatS";
import { Group, Text } from "@mantine/core";
import { isDefined, printify } from "../../Utils/utils";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({
  _document,
  formSubmission,
  position,
  taxType,
  values,
  handleChange,
  columnStyles,
}) => {
  const { windowWidth } = useContext(WindowContext);
  const { currency } = _document;
  const { discount, priceUnit, price, netPrice, tax } = position;
  const { amount: discountAmount } = discount;

  let styles = {
    container: {
      marginBottom: 5,
      display: "flex",
    },
    label: {
      fontWeight: 600,
      overflowWrap: "break-word",
      wordWrap: "break-word",
    },
    subtext: {},
    firstColumn: {
      ...columnStyles.firstColumn,
    },
    textColumn: {
      ...columnStyles.textColumn,
    },
    priceColumn: {
      ...columnStyles.priceColumn,
    },
  };

  let patchField = position.customAttributeId
    ? position.customAttributeId
    : position.id;
  let keys = [];
  let obj;

  for (obj in values) {
    if (values[obj]) {
      keys.push(obj);
    }
  }

  return (
    <>
      <div style={styles.container}>
        <div style={styles.firstColumn}>
          {position.optional && (
            <EditableFormAttributeValueProperty
              formSubmissionId={formSubmission.id}
              patchField={patchField}
              changeHandler={(p) => {
                handleChange(patchField, p[patchField]);
              }}
              entity={values}
              values={keys}
              labelValue={position.id + ""}
              editFormatter={EditableCheckbox}
              multiple={false}
              editOnly={true}
              disabled={formSubmission.lastSubmitted}
            />
          )}
        </div>
        <div style={styles.textColumn}>
          <div style={styles.label}>
            <div dangerouslySetInnerHTML={{ __html: position.label }} />
          </div>
          <div
            className={"description"}
            style={styles.subtext}
            dangerouslySetInnerHTML={{ __html: position.subtext }}
          />
        </div>
        {windowWidth > 800 && (
          <div style={styles.priceColumn}>
            {position.amount} {position.unit}
          </div>
        )}
        {windowWidth > 800 && (
          <div style={styles.priceColumn}>
            {priceUnit && (
              <div>
                {FormatS.formatPriceWithCurrency(
                  currency,
                  DocumentService.calculateNetGrossPrice(
                    taxType,
                    priceUnit,
                    tax
                  )
                )}
              </div>
            )}
          </div>
        )}
        <div style={styles.priceColumn}>
          <div>
            {windowWidth < 800 && !(position.amount == 1 && !isDefined(position.unit)) && (
              <Text size="xs" color="dimmed">{`${position.amount} ${printify(
                position.unit
              )}`}</Text>
            )}
            <b>
              {FormatS.formatPriceWithCurrency(
                currency,
                taxType === "net" ? netPrice : price
              )}
            </b>
          </div>
          {discountAmount > 0 && (
            <Text size="xs">{`Rabatt: ${FormatS.formatPriceWithCurrency(
              currency,
              discountAmount
            )}`}</Text>
          )}
        </div>
      </div>
    </>
  );
};
